export const SORT_OPTION = {
  MIN_PS_PRICE: 'MIN_PS_PRICE',
  MAX_PS_PRICE: 'MAX_PS_PRICE',
  VIDEO_QUALITY: 'VIDEO_QUALITY',
  MOST_VIEWERS: 'MOST_VIEWERS',
  LEAST_VIEWERS: 'LEAST_VIEWERS',
  YOUNGEST: 'YOUNGEST',
  OLDEST: 'OLDEST',
  PS_EARNINGS: 'PS_EARNINGS',
};

export const INTERVAL = {
  CAMS: 120000,
  SLIDER: 180000,
};

export const PS_ACTIONS = {
  START_PS: 'startPS',
  REQUEST: 'request',
  CANCEL_REQUEST: 'cancelRequest',
};

export const GENDER = {
  MALE: 'male',
  SHEMALE: 'shemale',
  COUPLE: 'couple',
  FEMALE: 'female',
  SOLO: 'solo',
  MALE_FEMALE_GROUP: 'male_female_group',
  MALE_GROUP: 'male_group',
  FEMALE_GROUP: 'female_group',
  ALL: 'all',
};

export const VIEW = {
  SINGLE: 'SINGLE',
  LIST: 'LIST',
};

export const DEFAULT_ACTIVE_PAGE = 1;
export const CAMS_PER_PAGE = 24;
// pixels
export const MEDIA_BREAKPOINT = 728;
export const MEDIA_BREAKPOINT_TABLET = 960;
export const DEFAULT_FILTERS_VALUE = 'all';

/**
 * range in format [minTokens, maxTokens]
 * if only 1 item in array [minTokens]
 */
export const getTokenOptions = [
  { range: [0, 10] },
  // eslint-disable-next-line no-magic-numbers
  { range: [11, 20] },
  // eslint-disable-next-line no-magic-numbers
  { range: [21, 30] },
  // eslint-disable-next-line no-magic-numbers
  { range: [31] },
];

export const getSortOptions = (translate) => [
  {
    label: translate('directory.tab.featuredCams'),
    value: SORT_OPTION.VIDEO_QUALITY,
  },
  {
    label: translate('profile.filter.lowestPrice'),
    value: SORT_OPTION.MIN_PS_PRICE,
  },
  {
    label: translate('profile.filter.highestPrice'),
    value: SORT_OPTION.MAX_PS_PRICE,
  },
  {
    label: translate('profile.filter.mostViewers'),
    value: SORT_OPTION.MOST_VIEWERS,
  },
  {
    label: translate('profile.filter.leastViewers'),
    value: SORT_OPTION.LEAST_VIEWERS,
  },
  {
    label: translate('profile.filter.youngest'),
    value: SORT_OPTION.YOUNGEST,
  },
  {
    label: translate('profile.filter.oldest'),
    value: SORT_OPTION.OLDEST,
  },
];
